import React from 'react';

export default function IdeasComponent() {
  return (
    <>
    </>
  )
}